import ManagerDiscoveryPlaceEdit from './ManagerDiscoveryPlaceEdit.container';

export default ManagerDiscoveryPlaceEdit;
